import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Row, Col ,Label } from "reactstrap"
import { AvCheckbox, AvCheckboxGroup, AvField, AvForm } from "availity-reactstrap-validation"
import { adminPrefix } from "configs/routePrefix"
import { toast } from "react-toastify"
import { SuccessOk } from "configs/statusCode"
import CancelModal from "components/CancelModal"
import Select from "react-select";
import SalesDeveloperService from "services/Admin/SalesDeveloperService"
import DeveloperService from "services/Admin/DeveloperService"

const languages = ["en", "ar", "zh", "ru"]
const initialRoles=[ 
  {label: "Send Avalibality" , value: "send_avalibality" ,status: false}, 
  {label: "Send Uploaded Recipt" , value: "send_uploaded_recipt",status: false}, 
  {label: "Send Client Information for Cash on Meeting" , value: "send_client_information_for_cash_on_meeting",status: false}, 
  {label: "Send Comparison" , value: "send_comparison", status: false}, 
  {label: "Sales Developer Send Mail for a Client" , value: "sales_developer_send_mail_for_a_client", status: false}, 
  {label: "Manage Inventory" , value: "manage_inventory", status: false}, 
  {label: "Manage Client" , value: "manage_client", status: false}, 
  {label: "Manage Client Status" , value: "manage_client_status", status: false}, 
  {label: "Manage Deals" , value: "manage_deals", status: false}, 
  {label: "Manage Deals Status"  , value: "manage_deals_status" ,status: false}, 
]
const manageCompound = [
  {label: "View" , value: "view_compound" ,status: false}, 
  {label: "Add" , value: "add_compound" ,status: false}, 
  {label: "Edit" , value: "edit_compound" ,status: false}, 
  {label: "Delete" , value: "delete_compound" ,status: false}, 
]
const initialState = {
  en: "", 
  ar: "",
  ru: "",
  zh: "",
  email: "",
  phone: "",
  developer: "",
  permissions: {}
}

const UpdateSalesDeveloperPage = (props) => {
  const salesDeveloperService = new SalesDeveloperService()
  const id = props.match.params.id
  const [formState, setFormState] = useState(initialState)
  const [roles, setRoles] = useState(initialRoles)
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [modal, setModal] = useState(false)
  const [loading,setLoading]= useState(false)
  const [permissions, setPermissions]= useState({})
  const [developerOptions, setDeveloperOptions]= useState([])

  useEffect(() => {
    salesDeveloperService.find(id).then(res => {
      let permissions = []
      let filtered = {}
      for (const key in res.data?.permissions) {
        if (res.data?.permissions[key] === true) {
          permissions.push(key);
          filtered[key] = true
        }
      }
      setSelectedRoles(permissions)
      setPermissions(filtered)
      setFormState({
        en: res.data.name.en,
        ar: res.data.name.ar,
        ru: res.data.name.ru,
        zh: res.data.name.zh,
        email: res.data.email,
        phone: res.data.phone,
        developer: {
          label: res.data.developer?.name?.en,
          value: res.data.developer?.id,
        }
      })

      // const updateArray = [...roles]
      // for(let key in res.data?.permissions){
      //   if(res.data?.permissions[key] == true){
      //     let index= roles.findIndex(item => item.value == key)
      //     updateArray[index]= {...updateArray[index], status: true}
      //     setRoles([...updateArray])
      //   }
      // }
    })
  }, [])

  useEffect(()=>{
    new DeveloperService().getDropDown().then(res=>{
      const newOptions = res.data.map(item => {
        return {
            label: item.name.en,
            value: item.id
        }
    })
    setDeveloperOptions(newOptions)
    })
  },[])

  const handleRolesChange = (value, e) => {
    if (selectedRoles.includes(value)) {
      setSelectedRoles(selectedRoles.filter((val) => val !== value));
    } else {
      setSelectedRoles([...selectedRoles, value]);
    }
    setPermissions({...permissions, [value]: e})
  };

  const handleValidSubmit = (e, v) => {
    let allRoles= {}
    roles.map(role=>{
      allRoles[role.value] = false
    })
    manageCompound.map(role=>{
      allRoles[role.value] = false
    })
    if(selectedRoles?.length == 0){
      toast.error("Select Role")
      return
    }
    setLoading(true)
    let developerId = null
    developerOptions?.map(dev=> {
      if(dev.label === formState.developer.label){
        developerId = dev.value
      }
    })
      
    const data = {
      name: { en: formState.en, },
      media_id: formState.media_id,
      email: formState.email,
      phone: formState.phone,
      developer_id: !!formState.developer.value ? formState.developer.value : developerId,
      permissions: {...allRoles, ...permissions }
    }

    languages.forEach(language => {
      if (formState[language].length) {
        data.name[language] = formState[language]
      }
    })

    salesDeveloperService.update(id, data).then(res => {
      if (res && res.status === SuccessOk) {
        props.history.push(`${adminPrefix}/sales-developer`)
        toast.success("updated successfully")
      }else {
        toast.error(res)
        setLoading(false)
      }
    })
  }

  const handleFieldChange = (e) => {
    setFormState({ ...formState, [e.target.name]: e.target.value })
  }

  return (
    <React.Fragment>
      <div className='page-content'>
        <MetaTags>
          <title>Sales Developer</title>
        </MetaTags>
        <Container fluid>
          <h4>
            Edit Sales Developer
          </h4>
          <AvForm
            className='form-horizontal'
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v)
            }}>
            <Card className="w-100 mt-4">
              <CardBody>
                <Row className="mb-4">
                  <Col md={6}>
                    <div className='mb-3'>
                      <AvField
                        errorMessage="This field is required"
                        name='en'
                        label="Sales Developer Name (en)"
                        className='form-control'
                        placeholder='English'
                        required
                        onChange={(e) => handleFieldChange(e)}
                        bsSize="lg"
                        value={formState.en}
                      />
                    </div>

                  </Col>
                  <Col md={6}>
                    <div className='mb-3'>
                      <AvField
                        name='ar'
                        label="Sales Developer Name (ar)"
                        className='form-control'
                        placeholder='Arabic'
                        required={false}
                        onChange={(e) => handleFieldChange(e)}
                        bsSize="lg"
                        value={formState.ar}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className='mb-3'>
                      <AvField
                        name='ru'
                        label="Sales Developer Name (ru)"
                        className='form-control'
                        placeholder='Russian'
                        required={false}
                        onChange={(e) => handleFieldChange(e)}
                        bsSize="lg"
                        value={formState.ru}
                      />
                    </div>

                  </Col>
                  <Col md={6}>
                    <div className='mb-3'>
                      <AvField
                        name='zh'
                        label="Sales Developer Name (zh)"
                        placeholder='Chinese'
                        className='form-control'
                        required={false}
                        onChange={(e) => handleFieldChange(e)}
                        bsSize="lg"
                        value={formState.zh}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <Label>Developer</Label>
                      <Select
                          placeholder='Select'
                          options={developerOptions}
                          onChange={data => setFormState({ ...formState, developer: data })}
                          value={formState.developer}
                          required
                      />
                  </Col>
                  <Col md={6}>
                    <div className='mb-3'>
                      <AvField
                        errorMessage="This field is required"
                        label="Email"
                        name='email'
                        value={formState.email}
                        className='form-control'
                        required
                        onChange={(e) => handleFieldChange(e)}
                        bsSize="lg"
                        placeholder={"developer@gmail.com"}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className='mb-3'>
                      <AvField
                        errorMessage="This field is required"
                        label="Phone"
                        name='phone'
                        placeholder={"123456789"}
                         className='form-control'
                        required
                        onChange={(e) => handleFieldChange(e)}
                        bsSize="lg"
                        type="number"
                        value={formState.phone}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                <Col md={12}>
                    <Label>Select Roles</Label>
                    <AvCheckboxGroup inline name="roles"
                    >
                      <Row>
                      <label className="text-muted mt-3 mb-0">Manage Compound</label>
                      {manageCompound?.map((role, index)=>{
                        return <Col md={3} className='mb-2'>
                          <AvCheckbox 
                            key={index}
                            label={role.label}
                            value={role.value}
                            checked={selectedRoles.includes(role.value)}
                            onChange={(e) => handleRolesChange(role.value,e.target.checked)}/>
                        </Col>
                      })}
                      <label className="text-muted mt-3 mb-0">Others</label>
                      {roles?.map((role, index)=>{
                        return <Col md={6}>
                          <AvCheckbox
                            key={index}
                            label={role.label}
                            value={role.value}
                            checked={selectedRoles.includes(role.value)}
                            onChange={(e) => handleRolesChange(role.value,e.target.checked)}/>
                        </Col>
                      })}
                      </Row>
                    </AvCheckboxGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <Row className="d-flex justify-content-between pb-4">
              <Col>
                <button
                  type="button"
                  className="btn btnUpload btnHeight px-4"
                  onClick={() => {
                    setModal(true)
                  }}
                  size={"lg"}>
                  Cancel
                  </button>
              </Col>
              <Col>
                <button
                  type='submit'
                  className="btn btn-success btnHeight px-4 float-end"
                  size={"lg"}
                  disabled={loading ?  true:false}
                >
                  Submit
                </button>
              </Col>
            </Row>
            <CancelModal modal={modal}
              setModal={setModal}
              goBackHandler={() => props.history.goBack()}
            />
          </AvForm>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default UpdateSalesDeveloperPage
